import React, { useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';
import useMenuRedirect from '../../../../hooks/useMenuRedirect';
import { builtItem } from '../../../../utils/buildItem';
import { filterNodes } from '../../../../utils/filterNodes';
import './style.scss';

export const DropDownMenu = ({ isDropDownActive, showDropDownMenu }) => {
  const { nodes, handleRedirect, nodesSelected } = useMenuRedirect();
  const previousNodeSelected = useSelector(
    state => state.cvNavData?.navData?.previousSelected || {},
  );

  const {
    playingLive_player_general_icon_nextChannel: activeIcon,
  } = useSelector(state => state.asset);
  const dropDownRef = useRef(null);

  let appBehavior = nodesSelected?.app_behaviour || '{}';
  appBehavior = JSON.parse(appBehavior);
  const isNodeToShowPrevious =
    appBehavior?.layout === 'playandgo' ||
    appBehavior?.layout === 'filterbygenre';

  const getNodesHeight = useCallback(
    () => {
      if (dropDownRef.current?.hasChildNodes()) {
        let heightResult = 0;

        for (const listItem of dropDownRef.current?.childNodes) {
          heightResult += listItem.offsetHeight;
        }
        return heightResult + 16;
      }

      return '0';
    },
    [nodes, dropDownRef.current],
  );

  const handleMenuClick = node => {
    showDropDownMenu(false);
    handleRedirect({ node });
  };

  const isTheCurrentNodeASubmenu  = nodes?.length > 0 && nodes?.find((node)=> ( node?.code === nodesSelected?.code))

  return (
    <ul
      className={`cv-drop-down-menu ${isDropDownActive ? 'active' : ''}`}
      ref={dropDownRef}
      style={{
        height: isDropDownActive ? getNodesHeight() : 0,
        padding: isDropDownActive ? '8px 0' : '0',
      }}
    >
      {nodes &&
        filterNodes(nodes)?.map(node => (
          <li
            key={`cv-drop-down-mobile-${node?.code}`}
            className="cv-drop-down-menu__item"
            onClick={() => handleMenuClick(node)}
          >
            {builtItem(node?.navImage, node?.code, node?.navIcon, node?.text)}


            {(nodesSelected?.code === node?.code 
                ||
               (isNodeToShowPrevious
                && previousNodeSelected?.code === node?.code 
                && !isTheCurrentNodeASubmenu)
              ) 
                && (
              <img
                src={activeIcon}
                alt={'cv'}
                className="cv-drop-down-menu__item__active"
              />
            )}
          </li>
        ))}
    </ul>
  );
};
